module.exports = __webpack_public_path__ + "img/174.74cd921f.jpg";